import { CHANGE_MODAL_STATE } from "store/reducers/newVersionModal/modal/types"
import { AppDispatch } from "store"

export const setNewVersionModalOpen = (isOpen: boolean): any => {
  return async (dispatch: AppDispatch) => {
    dispatch({
      type: CHANGE_MODAL_STATE,
      isOpen: isOpen
    })
  }
}